<template>
  <div class="segmented_nav">
    <h1 class="segmented_nav__title">{{ $t('common__webshop') }}</h1>
    <div class="segmented_nav__group">
      <template v-for="item in navItems">
        <span
          v-if="item.disabled"
          :key="item.key"
          class="seg_btn seg_btn--disabled"
          >{{ item.label }}</span
        >
        <router-link
          v-else-if="item.active"
          :key="item.key"
          :to="item.href"
          class="seg_btn seg_btn--active"
          >{{ item.label }}</router-link
        >
        <a
          v-else
          :key="item.key"
          :href="item.href"
          class="seg_btn"
          @click="onSelect(item)"
          >{{ item.label }}</a
        >
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { EventTracker } from '@/utils/event_tracker'

interface NavItem {
  key: string
  label: string
  href: string
  active: boolean
  disabled: boolean
}

// v2 の segmented-nav と同じ見た目のナビゲーション UI を表示する。
// Vue 側では状態管理は再現せず、「コイン」を常に active としたボタン見た目のリンクとして表示させる。
@Component
export default class SegmentedNav extends Vue {
  get navItems(): NavItem[] {
    return [
      {
        key: 'coin',
        label: this.$t('coinName') as string,
        href: '/mypage',
        active: true,
        disabled: false,
      },
      {
        key: 'premium',
        label: this.$t('common__premium') as string,
        href: '/r/premium',
        active: false,
        disabled: false,
      },
      {
        key: 'membership',
        label: this.$t('common__membership') as string,
        href: '/r/membership',
        active: false,
        disabled: false,
      },
      // TODO: ドリームスタンプ公開時に、導線に追加
      // {
      //   key: 'dream_stamp',
      //   label: this.$t('common__dream_stamp') as string,
      //   href: '/r/dream_stamp',
      //   active: false,
      //   disabled: true,
      // },
    ]
  }

  // 「コイン」は現在表示中のページ自身なので計測対象外
  onSelect(item: NavItem) {
    if (item.key === 'premium') {
      EventTracker.default.trackSelectPremiumButton()
    } else if (item.key === 'membership') {
      EventTracker.default.trackSelectMembershipButton()
    }
  }
}
</script>

<style scoped>
.segmented_nav {
  display: flex;
  flex-direction: column;
}

.segmented_nav__title {
  margin: 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  letter-spacing: 0.15px;
  color: #0f0f0f;
}

.segmented_nav__group {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 0;
  overflow-x: auto;
  /* no-scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.segmented_nav__group::-webkit-scrollbar {
  display: none;
}

.seg_btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 80px;
  min-height: 32px;
  padding: 6px 16px;
  border: none;
  border-radius: 16px;
  outline: 1.5px solid #e8e8e8;
  outline-offset: -1.5px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  letter-spacing: 0.25px;
  white-space: nowrap;
  background-color: #ffffff;
  color: #0f0f0f;
  text-decoration: none;
  cursor: pointer;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.seg_btn:hover {
  background-color: #f2f2f2;
}
.seg_btn:active {
  background-color: #e8e8e8;
}

.seg_btn--active {
  background-color: #188dff;
  color: #ffffff;
  outline: none;
}
.seg_btn--active:hover {
  background-color: #1786f2;
}
.seg_btn--active:active {
  background-color: #167fe5;
}

.seg_btn--disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
